import React, { forwardRef } from 'react'
import clsx from 'clsx'
import { FieldError, FieldErrorsImpl, Merge } from 'react-hook-form'

export type InputProps = {
  className?: string
  inputClassName?: string
  labelClassName?: string
  id: string
  label?: string
  type?: string
  name?: string
  value?: string
  placeholder?: string
  hiddenLabel?: boolean
  disabled?: boolean
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  error?: FieldError | Merge<FieldError, FieldErrorsImpl<any>> | undefined

  [key: string]: any
}

const Input = forwardRef(
  (
    {
      id,
      name,
      label,
      type = 'text',
      hiddenLabel,
      placeholder,
      onChange,
      className,
      inputClassName,
      labelClassName,
      disabled,
      value,
      error,
      children,
      required,
      ...rest
    }: InputProps,
    ref
  ) => {
    return (
      <div className={clsx('input-field', !!error && 'error', className)}>
        {label && (
          <label
            htmlFor={id}
            className={clsx(hiddenLabel && 'sr-only', labelClassName)}
          >
            {label}
            {/* {required && '*'} */}
          </label>
        )}

        <div className="input-field-inner relative">
          {(type == 'textarea') ? (
            <textarea
              // @ts-ignore
              ref={ref}
              name={name}
              id={id}
              className={clsx('input w-full', inputClassName)}
              placeholder={placeholder}
              onChange={onChange}
              value={value}
              disabled={disabled}
              required={required}
              {...rest}
            />
          ) : (
            <input
              // @ts-ignore
              ref={ref}
              type={type}
              name={name}
              id={id}
              className={clsx('input w-full', inputClassName)}
              placeholder={placeholder}
              onChange={onChange}
              value={value}
              disabled={disabled}
              required={required}
              {...rest}
            />
          )}

          {children}
        </div>

        {!!error?.message && typeof error.message === 'string' && (
          <div className="error-message first-letter:uppercase">
            {error.message}
          </div>
        )}
      </div>
    )
  }
)

export default Input
